import axios from "axios";

const API_BASE_URL =
  "https://4q9c8wra48.execute-api.us-west-1.amazonaws.com/prod";

export interface GarminQueryResponse {
  query: string;
  response: string;
  status: string;
  error?: string;
}

export interface GarminReportRequest {
  start_date?: string;
  end_date?: string;
  max_days?: number;
  send_email?: boolean;
}

export interface GarminReportResponse {
  response: string;
  date_range?: {
    start_date?: string;
    end_date?: string;
  };
  status: string;
  error?: string;
}

export default class GarminApiClient {
  async query(query: string): Promise<GarminQueryResponse> {
    const response = await axios.post(`${API_BASE_URL}/garmin/query`, {
      query,
    });
    return response.data;
  }

  async report(request: GarminReportRequest): Promise<GarminReportResponse> {
    const response = await axios.post(`${API_BASE_URL}/garmin/report`, request);
    return response.data;
  }
}
